import { writable } from 'svelte/store'

const storage = sessionStorage

const storedToken = storage.getItem('token') || ''
const storedAccount = storage.getItem('account') || ''

export const token = writable(storedToken)
export const account = writable(storedAccount)

token.subscribe(value => {
  if (value !== storedToken) storage.setItem('token', value)
})

account.subscribe(value => {
  if (value !== storedAccount) storage.setItem('account', value)
})
